/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

import axiosInstance from "../../../../apiConfigs/axiosInstance";
import { ERROR__TOASTER } from "../../../../helpers/utils/TosterError";
import { renderDynamicUrlFromState } from "../../../../helpers/utils/urlHelper";

export interface InterviewUsersParams {
  subdomain?: string;
  page?: number;
  limit?: number;
  search?: string;
}

export interface InterviewUsersResponse {
  success: boolean;
  data: any[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  stats: {
    totalUsers: number;
    activeUsers: number;
    totalAvgPerformance: number;
    totalInterviews: number;
  };
}

export const fetchInterviewUsers = createAsyncThunk(
  "interviewUsers/fetchInterviewUsers",
  async (
    params: InterviewUsersParams,
    { dispatch, rejectWithValue, getState }
  ) => {
    try {
      let url =
        "https://backend.joindojo.ai/api/company-admin/interview-users/public";

      // Add subdomain as query parameter if it's "theagileacademy" or "aa"
      const queryParams = new URLSearchParams();
      if (params.subdomain === "theagileacademy" || params.subdomain === "aa") {
        queryParams.append("subdomain", params.subdomain);
      }
      if (params.page) {
        queryParams.append("page", params.page.toString());
      }
      if (params.limit) {
        queryParams.append("limit", params.limit.toString());
      }
      if (params.search) {
        queryParams.append("search", params.search);
      }

      if (queryParams.toString()) {
        url += `?${queryParams.toString()}`;
      }

      const response = await axiosInstance.get(url);

      if (response.data && response.data.data && response.data.data.users) {
        const pagination = response.data.pagination || {};

        return {
          success: true,
          data: response.data.data.users,
          total: pagination.totalItems || response.data.data.users.length,
          page: pagination.currentPage || 1,
          limit: pagination.itemsPerPage || response.data.data.users.length,
          totalPages: pagination.totalPages || 1,
          stats: response.data.data.stats,
        } as InterviewUsersResponse;
      }
      return rejectWithValue(
        response.data?.message || "Failed to fetch interview users"
      );
    } catch (error: any) {
      ERROR__TOASTER(error);
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch interview users"
      );
    }
  }
);
